var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDotpeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21690 22589)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "translate(-21690 -22589)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5882.34 -13680.277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.256,0a2.859,2.859,0,0,1,2.851,2.868V14.335A2.859,2.859,0,0,1,14.256,17.2H2.852A2.859,2.859,0,0,1,0,14.335V2.868A2.859,2.859,0,0,1,2.852,0ZM4.99,5.735A1.673,1.673,0,1,0,6.653,7.408,1.673,1.673,0,0,0,4.99,5.735Zm7.128,0a1.673,1.673,0,1,0,1.663,1.673,1.673,1.673,0,0,0-1.663-1.673Z",
    transform: "translate(-15792.214 -8901.324)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-21679 -22553)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Mont-HeavyDEMO, Mont",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DotPe")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDotpeLogo);
export default __webpack_public_path__ + "static/media/ic-dotpe-logo.e37fd29e3fc2842f3d5cb4cb151651d8.svg";
export { ForwardRef as ReactComponent };